app.controller('freeGameIndexCtrl', [
    '$scope', '$rootScope', '$http', '$mdToast', '$state', 'mdContentService', function ($scope, $rootScope, $http, $mdToast, $state, mdContentService) {
    	var vm = this;

        vm.loaded = false;
        vm.game = null;
        vm.allExercises = [];
        vm.selectedExercise = -1;
        vm.exercises = [];

        vm.getExercise = function(id) {
            for (var i = 0; i < vm.allExercises.length; i++) {
                var exercise = vm.allExercises[i];
                if (exercise.id === id) {
                    return exercise;
                }
            }
            return null;
        }

        vm.onExerciseSelected = function() {
            if (vm.selectedExercise === -1) {
                return;
            }

            var exercise = vm.getExercise(vm.selectedExercise);
            var exerciseCopy = angular.copy(exercise);
            vm.exercises = [exerciseCopy];

            vm.selectedExercise = -1;
        }

        vm.removeExercise = function(idx) {
            var newExercises = [];
            for (var i = 0; i < vm.exercises.length; i++) {
                if (i == idx) {
                    continue;
                }
                newExercises.push(vm.exercises[i]);
            }
            vm.exercises = newExercises;
        }

        $http.get('/api/freegame').then(function(response) {
            var freeGameData = response.data;
            $http.get('/api/exercise').then(function(response) {
                vm.loaded = true;
                vm.game = freeGameData;
                vm.exercises = vm.game.exercises;
                if (!vm.exercises) {
                    vm.exercises = [];
                }
                for (var i = 0; i < vm.exercises.length; i++) {
                    vm.exercises[i].index = i;
                }
                vm.allExercises = response.data.items;

                mdContentService.triggerSyntheticScrollEvent();
            });
        });

        vm.save = function() {
            var model = {
                key: "main",
                created: 0,
                modified: 0,
                startTime: 0,
                timeImageURL: "",
                teamMembers: [],
                teamName: "",
                exercises: vm.exercises
            };
            $http.post('/api/freegame', model).then(function() {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent("Øvelsesopgave gemt")
                    .position('top right')
                    .hideDelay(3000)
                );
                $state.reload();
            });
        }
    }
]);